import { PATIENT_TAB_IDS } from '@/components/Patient/Patient.constants';

interface BuildPatientConsultationUrlParams {
  consultation: { id: number; patient_id: number };
  isConsultActive: boolean;
  isDoc: boolean;
  isGDCEnabled?: boolean;
}

const buildPatientConsultationUrl = ({
  consultation,
  isConsultActive,
  isDoc,
  isGDCEnabled,
}: BuildPatientConsultationUrlParams) => {
  const { id: consultationId, patient_id: patientId } = consultation;

  if (!isConsultActive || !isGDCEnabled || !isDoc) {
    return `/patients/${patientId}?show=${PATIENT_TAB_IDS.CONSULTATIONS}`;
  }

  return `/patients/${patientId}?show=${PATIENT_TAB_IDS.SCHEDULED_CONSULT}&scheduledConsult=${consultationId}`;
};

export { buildPatientConsultationUrl };
